import * as React from "react";
import { faTimesCircle, faCheckCircle, faHourglassEnd, faExclamation, faHourglassHalf } from "@fortawesome/free-solid-svg-icons";
import { CredDefenseStatusEnum } from 'src/services/Enum/credDefense/CredDefenseStatusEnum';
import { IconConfig } from '../GenericIcon/IconConfig';
import ICredDefense from 'src/services/interfaces/prefraud/credDefense/ICredDefense';
import { GenericIcon } from '../GenericIcon/GenericIcon';

export function CredDefenseIcon(props: { credDefense: ICredDefense }) {
  const CredDefenseIcons: IconConfig<CredDefenseStatusEnum> = {
    AWAITING: {
      icon: faHourglassHalf,
      label: "Aguardando a selfie do usuário",
      className: "warning"
    },
    RECEIVED: {
      icon: faCheckCircle,
      label: "Solicitação finalizada, usuário tirou a selfie",
      className: "success"
    },
    MANUAL_SELFIE_SENT: {
      icon: faCheckCircle,
      label: "Solicitação finalizada, selfie enviada manualmente",
      className: "success"
    },
    EXPIRED: {
      icon: faHourglassEnd,
      label: "Solicitação expirou pois usuário não tirou a selfie, execute novamente em contingência ou envie manualmente",
      className: "warning"
    },
    REVIEW_DATA: {
      icon: faExclamation,
      label: "Erro de validação, clique em visualizar",
      className: "apiError"
    },
    API_ERROR: {
      icon: faTimesCircle,
      label: "Erro na solicitação, clique para visualizar",
      className: "apiError"
    },
    SHOULD_NOT_RUN: {
      icon: faCheckCircle,
      label: "Não é necessario capturar Selfie",
      className: "success"
    }
  };

  return props.credDefense && <GenericIcon showLabel={true} iconConfig={CredDefenseIcons[props.credDefense.status]} />;
}



// WEBPACK FOOTER //
// ./src/components/common/Icons/CredDefense/CredDefenseIcon.tsx